export default {
    'create-status': 'crear estado',
    headers: {
        name: 'nombre',
        'invoice-type': 'tipo de factura',
        'is-final-status': 'estado final'
    },
    'create-delivery-status' : 'crear estado de entrega',
    'edit-delivery-status' : 'es el estado final',

    delete: {
        'delete-delivery-status': 'eliminar estado de entrega',
        'delete-dialog-content': '¿Está seguro de que desea eliminar este estado de entrega?',
    },

    inputs: {
        'delivery-name': 'nombre de entrega',
        'invoice-type': 'tipo de factura',
        'final-status': 'establecer como estado final'
    },

    chips: {
        true: 'true',
        false: 'false'
    },
    
    buttons: {
        add: 'agregar',
        edit: 'editar',
        delete: 'borrar',
        cancel: 'cancelar'
    }
}